import React from 'react';
import { Col, Container, NavLink, Row } from 'react-bootstrap';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer-bg">
            <Container>
                <Row className="text-white">
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Useful Link</h2>
                            </div>
                            <div className="widget-content">
                                <NavLink className="footer-link">Home</NavLink>
                                
                                <NavLink className="footer-link">About</NavLink>
                                <NavLink className="footer-link">Contact Us</NavLink>
                                <NavLink className="footer-link">Gallery</NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Department</h2>
                            </div>
                            <div className="widget-content">
                                <NavLink className="footer-link">NEPHROLOGY</NavLink>
                                <NavLink className="footer-link">UROLOGY</NavLink>
                                <NavLink className="footer-link">  GASTROENTEROLOGIST</NavLink>
                                <NavLink className="footer-link">NEUROLOGIST</NavLink>
                                <NavLink className="footer-link">GYNAECOLOGIST</NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Facilities</h2>
                            </div>
                            <div className="widget-content">
                                <NavLink className="footer-link">I.C.U.</NavLink>
                                <NavLink className="footer-link">N.I.C.U.</NavLink>
                                <NavLink className="footer-link">X-RAY</NavLink>
                                <NavLink className="footer-link">PATHOLOGY</NavLink>
                                <NavLink className="footer-link">ULTRASOUND</NavLink>
                                <NavLink className="footer-link">OPERATION  THEATRE </NavLink>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={3}>
                        <div className="single-footer-widget">
                            <div className="widget-title">
                                <h2>Our Address</h2>
                            </div>
                            <div className="widget-content" >
                                <NavLink className="footer-link">1/17 Vardan khand</NavLink>
                                <NavLink className="footer-link">Sector-1  Gomti Nagar Vistar lucknow 226010</NavLink>
                                <NavLink className="footer-link">Phone: +91 9120921185</NavLink>
                                <NavLink className="footer-link" >Email: sushenamedical@gmail.com</NavLink>
                                
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="footer-copy-right text-center text-white">
                <p className='mb-0'>&copy; 2023 - <span className="developer">All Rights Reserved</span> | and Developed by  Creative Digital World</p>
            </div>
        </div>
    );
};

export default Footer;